import React, { useEffect, useState } from "react";
import StaffHeader from "./StaffHeader";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { ToastMain, SweetAlertShow } from "../master/Master";
import { getstaffwithid } from "../../api/FacultyService";
import { StaffList } from "../../api/Staff";
import { getSessions } from "../../api/SessionsService";
import { imgBaseUrl } from "../../api/api";

const CCCertificate = () => {
  const [loading, setLoading] = useState(false);
  const instituteData = JSON.parse(localStorage.getItem("setting")) || {};
  const [type, setType] = useState("");
  const [session, setSession] = useState("");
  const [selectedSession, setSelectedSession] = useState("");
  const [staff, setStaff] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState("");
  const [experience, setExperience] = useState();
  const [classLevel, setClassLevel] = useState("");
  const [singleStaff, setSingleStaff] = useState("");
  const [behaviour, setBehaviour] = useState("");

  const getSession = async () => {
    setLoading(true);
    try {
      const response = await getSessions();
      if (response?.data?.status) {
        const ActiveSession = response?.data?.data?.find(
          (s) => s?.status == "1"
        );
        setSession(response?.data);
        setSelectedSession(ActiveSession?.id);
      } else {
        // ToastMain.fire({
        //     icon: 'info',
        //     title: response?.data?.messsage || 'something went wrong'
        // })
        SweetAlertShow("info", "Warning", response?.data?.messsage);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.messsage ?? error?.messsage
      );
      // ToastMain.fire({
      //     icon: 'error',
      //     title: error?.response?.data?.messsage || 'something went wrong'
      // })
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  const getStaff = async () => {
    setLoading(true);
    const addUrl = `&session_id=${selectedSession}`;
    try {
      const response = await StaffList(addUrl);
      if (response?.data?.status) {
        setStaff(response?.data?.data || []);
      } else {
        // ToastMain.fire({
        //     icon: 'info',
        //     title: response?.data?.messsage || 'something went wrong'
        // })
        SweetAlertShow("info", "Warning", response?.data?.messsage);
      }
    } catch (error) {
      // ToastMain.fire({
      //     icon: 'error',
      //     title: error?.response?.data?.messsage || 'something went wrong'
      // })

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.messsage ?? error?.messsage
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedSession) {
      getStaff();
    }
  }, [selectedSession]);

  const StaffById = async (selectedStaff) => {
    setLoading(true);
    // const addUrl = `id=${selectedStaff}`
    try {
      const response = await getstaffwithid(selectedStaff);
      if (response?.data?.status) {
        setSingleStaff(response?.data?.data || []);
      } else {
        

        SweetAlertShow("info", "Warning", response?.data?.messsage);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.messsage ?? error?.messsage
      );
     
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedStaff) {
      StaffById(selectedStaff);
    }
  }, [selectedStaff]);

  const handlePrintCertificate = (
    staff,
    instituteData,
    behaviour,
    imgBaseUrl
  ) => {
    const printWindow = window.open("", "_blank");

    const issueDate = new Date().toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    printWindow.document.write(`
    <html>
    <head>
        <title>Character Certificate</title>
        <style>
            body {
                font-family: Arial, sans-serif;
                margin: 50px;
                line-height: 1.8;
                background: #fff;
            }
            .certificate {
                border: 2px solid #000;
                padding: 40px;
                position: relative;
                overflow: hidden;
            }

            /* Watermark */
            .watermark {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(-25deg);
                font-size: 40px;
                color: rgba(0, 0, 0, 0.05);
                font-weight: 700;
                text-transform: uppercase;
                pointer-events: none;
                white-space: nowrap;
            }

            /* Header */
            .header {
                display: flex;
                align-items: center;
                justify-content: center;
                border-bottom: 2px solid #000;
                padding-bottom: 10px;
                margin-bottom: 25px;
            }
            .logo img {
                width: 80px;
                height: 80px;
                object-fit: contain;
            }
            .school-info {
                text-align: center;
                margin-left: 15px;
            }
            .school-info h2 {
                margin: 0;
                font-size: 22px;
                font-weight: bold;
            }
            .school-info p {
                margin: 3px 0;
                font-size: 14px;
            }

            /* Content */
            .content h3 {
                text-align: center;
                text-decoration: underline;
            }

            /* Footer */
            .footer {
                margin-top: 60px;
                display: flex;
                justify-content: space-between;
            }
            .sign {
                width: 40%;
                text-align: center;
                border-top: 1px solid #000;
                padding-top: 8px;
                font-size: 14px;
                font-weight: bold;
            }

            .dates {
                text-align: right;
                margin-top: 30px;
                font-size: 14px;
            }

            @media print {
                .watermark {
                    color: rgba(0,0,0,0.08);
                }
            }
        </style>
    </head>

    <body>
        <div className="certificate">

            <!-- Watermark -->
            <div className="watermark">${(
              instituteData?.name || "SCHOOL"
            ).toUpperCase()}</div>

            <!-- Header -->
            <div className="header">
                <div className="logo">
                    <img src="${
                      instituteData?.logo_img
                        ? `${imgBaseUrl}${instituteData.logo_img}`
                        : "/files/logo.png"
                    }" />
                </div>
                <div className="school-info">
                    <h2>${instituteData?.name || "SCHOOL ERP SYSTEM"}</h2>
                    <p>${
                      instituteData?.address ||
                      `${instituteData?.village || ""}, ${
                        instituteData?.district || ""
                      } (${instituteData?.state || ""})`
                    }</p>
                    <p>Contact: ${instituteData?.phone || ""} | Email: ${
      instituteData?.email || ""
    }</p>
                </div>
            </div>

            <!-- Content -->
            <div className="content">
                <h3>Character Certificate</h3>

                <p>
                    This is to certify that 
                    <b>${staff?.gender === "Female" ? "Ms." : "Mr."} ${
      staff?.name
    }</b> 
                    has been known to our institution.
                </p>

                <p>
                    As per our evaluation, his/her character and behaviour is 
                    <b>${behaviour || "________________"}</b>.
                </p>

                <p>
                    During the period associated with us, ${
                      staff?.name?.split(" ")[0]
                    } has shown discipline, good moral conduct and cooperative nature.
                </p>

                <p>
                    We extend our best wishes to ${
                      staff?.name?.split(" ")[0]
                    } for a successful and bright future ahead.
                </p>

                <div className="dates">
                    <p><b>Issue Date:</b> ${issueDate}</p>
                </div>
            </div>

            <!-- Footer -->
            <div className="footer">
                <div className="sign">Authorized Signatory</div>
                <div className="sign">${instituteData?.name || ""}</div>
            </div>

        </div>

        <script>
            window.print();
            window.onafterprint = function() { window.close(); }
        </script>
    </body>
    </html>
    `);

    printWindow.document.close();
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />

            <div className="container-fluid mt-2">
              <div className="row custom-scroll-layout">
                <div className="col-md-2 left-pane">
                  <StaffHeader data={"Staff Portal"} />
                </div>
                <div className="col-md-10 right-pane">
                  <div className="card">
                    <div className="card-body">
                      <h3>Character Certificate</h3>

                      <div className="row">
                        {/* Select Staff */}
                        <div className="col-md-4">
                          <div className="form-floating form-floating-outline">
                            <select
                              className="form-select"
                              name="staff_id"
                              value={selectedStaff}
                              onChange={(e) => setSelectedStaff(e.target.value)}
                            >
                              <option>Select Staff</option>
                              {staff?.map((item) => (
                                <option key={item?.id} value={item?.id}>
                                  {item?.name} : ({item?.staff_type})
                                </option>
                              ))}
                            </select>
                            <label>Select Staff</label>
                          </div>
                        </div>

                        {/* Behavior Input */}
                        <div className="col-md-4">
                          <div className="form-floating form-floating-outline">
                            <input
                              type="text"
                              placeholder="Enter Character Behavior"
                              className="form-control"
                              value={behaviour}
                              onChange={(e) => setBehaviour(e.target.value)}
                            />
                            <label>Character / Behaviour</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Certificate Preview */}
                  <div className="card mt-3">
                    <div className="card-body">
                      <div className="col-md-8 mx-auto">
                        {singleStaff && singleStaff?.name && (
                          <div
                            className="certificate-preview shadow p-4 rounded"
                            style={{
                              lineHeight: 1.8,
                              backgroundColor: "#fff",
                              border: "2px solid #009688",
                              fontFamily: "Arial, sans-serif",
                              color: "#000",
                            }}
                          >
                            {/* Header */}
                            <div className="border-bottom pb-2 mb-3 text-center">
                              <div className="d-flex align-items-center justify-content-center mb-2">
                                <img
                                  src={
                                    instituteData?.logo_img
                                      ? `${imgBaseUrl}${instituteData.logo_img}`
                                      : "/files/logo.png"
                                  }
                                  alt="School Logo"
                                  style={{
                                    width: "70px",
                                    height: "70px",
                                    objectFit: "contain",
                                    marginRight: "15px",
                                  }}
                                />
                                <div>
                                  <h5
                                    className="mb-0"
                                    style={{
                                      color: "#009688",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {instituteData?.name ||
                                      "SCHOOL ERP SOFTWARE"}
                                  </h5>
                                  <p
                                    className="mb-0"
                                    style={{ fontSize: "13px" }}
                                  >
                                    {instituteData?.address ||
                                      `${instituteData?.village || ""}, ${
                                        instituteData?.district || ""
                                      } (${instituteData?.state || ""})`}
                                  </p>
                                  <p
                                    className="mb-0"
                                    style={{ fontSize: "13px" }}
                                  >
                                    Contact:{" "}
                                    {instituteData?.phone ||
                                      instituteData?.mobile ||
                                      "N/A"}{" "}
                                    | {instituteData?.email || ""}
                                  </p>
                                </div>
                              </div>
                            </div>

                            {/* Title */}
                            <h4
                              className="text-center mb-3"
                              style={{
                                fontWeight: "bold",
                                textDecoration: "underline",
                              }}
                            >
                              Character Certificate
                            </h4>

                            {/* Body */}
                            <div className="px-3">
                              <p>
                                This is to certify that{" "}
                                <b>
                                  {singleStaff?.gender === "Female"
                                    ? "Ms."
                                    : "Mr."}{" "}
                                  {singleStaff?.name}
                                </b>{" "}
                                has been working with{" "}
                                <b>{instituteData?.name}</b>.
                              </p>

                              <p>
                                Based on our observation, his/her character &
                                behaviour is{" "}
                                <b>{behaviour || "_______________"}</b>.
                              </p>

                              <p>
                                {singleStaff?.name?.split(" ")[0]} has
                                maintained good discipline and has never been
                                involved in any activity against the rules of
                                the institution.
                              </p>

                              <p>
                                We wish {singleStaff?.name?.split(" ")[0]} a
                                bright and successful future ahead.
                              </p>

                              {/* Issue Date */}
                              <p className="text-end mt-4">
                                <b>Issue Date:</b>{" "}
                                {new Date().toLocaleDateString("en-IN", {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric",
                                })}
                              </p>
                            </div>

                            {/* Footer */}
                            <div className="d-flex justify-content-between mt-5 px-4">
                              <div
                                style={{
                                  width: "40%",
                                  borderTop: "1px solid #000",
                                  textAlign: "center",
                                  paddingTop: "6px",
                                  fontWeight: "bold",
                                }}
                              >
                                Authorized Signatory
                              </div>
                              <div
                                style={{
                                  width: "40%",
                                  borderTop: "1px solid #000",
                                  textAlign: "center",
                                  paddingTop: "6px",
                                  fontWeight: "bold",
                                }}
                              >
                                {instituteData?.name || ""}
                              </div>
                            </div>

                            {/* Print Button */}
                            <div className="text-center mt-4">
                              <button
                                className="btn btn-primary"
                                onClick={() =>
                                  handlePrintCertificate(
                                    singleStaff,
                                    instituteData,
                                    behaviour,
                                    imgBaseUrl
                                  )
                                }
                              >
                                <i className="fa fa-print me-2"></i> Print
                                Certificate
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CCCertificate;
